"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMyEditProfileLink = void 0;
const auth_1 = __importDefault(require("../../auth"));
const getMyEditProfileLink = () => {
    var _a;
    const baseDomain = (_a = auth_1.default === null || auth_1.default === void 0 ? void 0 : auth_1.default.getInstance()) === null || _a === void 0 ? void 0 : _a.getBaseDomain();
    return `https://my.${baseDomain}/account/my-account/edit-profile?activeNav=manageAccountEditProfile`;
};
exports.getMyEditProfileLink = getMyEditProfileLink;
